




















































































import { RouterNames } from "@/router/routernames";
import { lecturas_codigo_barras } from "@/shared/dtos/lecturas_codigo_barras";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { DxForm, DxSimpleItem, DxGroupItem } from "devextreme-vue/form";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { ProcessoNums, getTexto } from "../procesos/ProcessoNums";
import ProcesosProducto from "../procesos/Procesos_producto.vue";
import { UtilsString } from "@/utils/utils-string";
@Component({
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    ProcesosProducto,
  },
})
export default class ProductoEscaneado extends Vue {
  public bar_code: lecturas_codigo_barras = new lecturas_codigo_barras();
  public ALERTA: string = "";
  public producto: any = null;
  public precio_venta = 0;

  @PropSync("BarCode", { default: "" }) bar_code_string!: string;

  async created() {
    console.log("Created" + this.bar_code_string);
    await productoModule.getproductos();

    this.bar_code = new lecturas_codigo_barras();

    if (this.$route.params.BarCode !== undefined) {
      this.bar_code_string = this.$route.params.BarCode;

      this.bar_code.referencia = this.$route.params.BarCode;
    } else {
      this.bar_code.referencia = this.bar_code_string;
    }

    this.onScan(this.bar_code.referencia);
  }

  get barcode_not() {
    if (this.$route.params.BarCode !== undefined) {
      return UtilsString.IsNullOrWhiteSpace(this.bar_code.referencia);
    } else {
      return UtilsString.IsNullOrWhiteSpace(this.bar_code_string);
    }
  }

  onUnitRetailChange(e: any) {
    // Calculamos el coste como el 50% de unit_retail
    this.producto.precio_venta =
      Math.round(
        (this.producto.total_retail ? this.producto.total_retail * 0.5 : 0) *
          100
      ) /
        100 +
      " €";
    this.producto.precio_venta = e.value * 0.5;
  }
  estadolChange(e: any) {
    this.producto.estado = getTexto(this.producto.estado);
  }

  @Watch("bar_code_string")
  BarcodeChange() {
    this.bar_code = new lecturas_codigo_barras(this.bar_code_string);
    this.onScan(this.bar_code_string, true);
  }

  onScan(BarCode: string, viene_what: boolean = false) {
    // handle the message here :)
    if (viene_what) {
      console.log("Whatch" + BarCode);
    }
    if (UtilsString.IsNullOrWhiteSpace(BarCode)) {
      return;
    }

    console.log("BarCode" + BarCode);

    // Buscar el producto escaneado
    this.producto = productoModule.productos.find(
      (x) => x.lpn.toLowerCase() === BarCode!.toLowerCase()
    );
    this.producto.precio_venta =
      Math.round(
        (this.producto.total_retail ? this.producto.total_retail * 0.5 : 0) *
          100
      ) /
        100 +
      " €";
    this.producto.estado = getTexto(this.producto.estado);

    if (this.producto) {
      this.ALERTA = "";
    } else {
      //alert("Producto no encontrado.");
      this.ALERTA = "Producto no encontrado.";
    }
  }

  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  goto() {
    this.$router.back();
  }
}
